<template>
  <div class="skeleton-lista" aria-busy="true" aria-label="Cargando">
    <div v-for="n in filas" :key="n" class="skeleton-lista__fila" :class="{ 'skeleton-lista__fila--tarjeta': tarjetas }">
      <v-skeleton-loader v-for="c in columnas" :key="c" type="text" class="skeleton-lista__celda"></v-skeleton-loader>
    </div>
  </div>
</template>

<script>
/** Esqueleto de un listado mientras llega la primera respuesta del servidor. */
export default {
  name: "SkeletonLista",
  props: {
    filas: { type: Number, default: 6 },
    columnas: { type: Number, default: 5 },
    tarjetas: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.skeleton-lista {
  padding: 8px 4px;
}
.skeleton-lista__fila {
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.skeleton-lista__celda {
  flex: 1;
}
.skeleton-lista__fila--tarjeta {
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
}
</style>
